import ChangePw from "../../../Components/Admin/ChangePw";

const ChangePwPage = () => {
  return <ChangePw />;
};

export default ChangePwPage;
